module.exports = __webpack_public_path__ + "img/安评公众号二维码.98be9c18.98be9c18.jpg";